export default __webpack_public_path__ + "static/media/subscriptions.688cb3e1.png";